export const PRICE_RANGE: [number, number][] = [
  [59000, 200000],
  [44000, 200000],
];
